import { render, staticRenderFns } from "./HeaderHorizon2.vue?vue&type=template&id=f278c9de"
import script from "./HeaderHorizon2.vue?vue&type=script&lang=js"
export * from "./HeaderHorizon2.vue?vue&type=script&lang=js"
import style0 from "./HeaderHorizon2.vue?vue&type=style&index=0&id=f278c9de&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f278c9de')) {
      api.createRecord('f278c9de', component.options)
    } else {
      api.reload('f278c9de', component.options)
    }
    module.hot.accept("./HeaderHorizon2.vue?vue&type=template&id=f278c9de", function () {
      api.rerender('f278c9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/HeaderHorizon2.vue"
export default component.exports